var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigestEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "71px",
    height: "70px",
    viewBox: "0 0 71 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AssetType_digest-BIG",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.0555556,70 C69.2340121,70 71,68.2588851 71,66.1111111 L71,3.88888889 C71,1.74111486 69.2340121,0 67.0555556,0 L3.94444444,0 C1.76598793,0 0,1.74111486 0,3.88888889 L0,66.1111111 C0,68.2588851 1.76598793,70 3.94444444,70 L67.0555556,70 Z M63.8101266,62.8205128 L32.3544304,62.8205128 L32.3544304,28.2482906 C32.3628732,28.1058203 32.3628732,27.9629832 32.3544304,27.8205128 L63.8101266,27.8205128 L63.8101266,62.8205128 Z M7.12862441,8 L64.0157719,8 L64.0157719,20.6410256 L7.12862441,20.6410256 L7.12862441,8 Z M7.18987342,27.8205128 L23.3670886,27.8205128 C23.3584046,27.9629832 23.3584046,28.1058203 23.3670886,28.2482906 L23.3670886,62.8205128 L7.18987342,62.8205128 L7.18987342,27.8205128 Z",
    id: "Shape-Copy-5",
    stroke: "#FFFFFF",
    fill: "#7E7E7E",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigestEmail);
export default __webpack_public_path__ + "static/media/Digest-email.a780c1bd.svg";
export { ForwardRef as ReactComponent };